import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import cs from 'classnames';

interface IProps {
    text: string;
    position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    className?: string;
    classNames?: {
        tooltip?: string;
        tooltipContent?: string;
    };
    isFixedWidth?: boolean;
    isWhite?: boolean;
}

export const Hint: FC<IProps> = ({text, className, position = 'top-left', classNames, isFixedWidth, isWhite}) => {
    return (
        <span className={cs(className, style.main, {[style.isFixedWidth]: isFixedWidth, [style.isWhite]: isWhite})}>
            <Icon className={style.icon} icon={'question-filled'} />
            <span className={cs(classNames?.tooltip, style.tooltip, style[position])}>
                <span className={cs(classNames?.tooltipContent, style.tooltipContent)}>
                    <Typography variant={'label-12-r'}>{text}</Typography>
                </span>
            </span>
        </span>
    );
};
